import { mcpTokenConstants } from "../constants/mcpToken.constants";

export function mcpToken(state = {}, action) {
  switch (action.type) {
    case mcpTokenConstants.GET_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case mcpTokenConstants.GET_SUCCESS:
      return {
        ...state,
        loading: false,
        tokens: action.payload,
      };
    case mcpTokenConstants.GET_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case mcpTokenConstants.GET_BY_ID_REQUEST:
      return {
        ...state,
        loadingDetail: true,
        error: null,
      };
    case mcpTokenConstants.GET_BY_ID_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        selectedToken: action.payload,
      };
    case mcpTokenConstants.GET_BY_ID_FAILURE:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload,
      };
    case mcpTokenConstants.CREATE_REQUEST:
      return {
        ...state,
        creating: true,
        createSuccess: false,
        error: null,
      };
    case mcpTokenConstants.CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        createSuccess: true,
        createdToken: action.payload,
      };
    case mcpTokenConstants.CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        createSuccess: false,
        error: action.payload,
      };
    case mcpTokenConstants.UPDATE_REQUEST:
      return {
        ...state,
        updating: true,
        updateSuccess: false,
        error: null,
      };
    case mcpTokenConstants.UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        updateSuccess: true,
      };
    case mcpTokenConstants.UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        updateSuccess: false,
        error: action.payload,
      };
    case "CLEAR_MCP_TOKEN_SUCCESS":
      return {
        ...state,
        createSuccess: false,
        updateSuccess: false,
        createdToken: null,
      };
    default:
      return state;
  }
}
